// extracted by mini-css-extract-plugin
module.exports = {"title":"ratesDetail-module--title--1vDN6","subhed":"ratesDetail-module--subhed--2p0CY"};